export default "__VITE_ASSET__3f67e0b5__"